import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { useAdminAuth } from "./useAdminAuth";

const adminApi = axios.create({ baseURL: "/api/admin" });

const headers = (token: string | null) => ({
  Authorization: token ? `Bearer ${token}` : "",
});

export interface PromptResponse {
  prompt: string;
  default: string;
  isCustom: boolean;
}

export const usePrompt = () => {
  const { token } = useAdminAuth();
  return useQuery<PromptResponse>(
    "admin-prompt",
    async () => {
      const res = await adminApi.get<{ data: PromptResponse }>("/prompt", {
        headers: headers(token),
      });
      return res.data.data;
    },
    { enabled: !!token, cacheTime: 5 * 60 * 1000 }
  );
};

export const useSavePrompt = () => {
  const { token } = useAdminAuth();
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>(
    async (prompt) => {
      await adminApi.put("/prompt", { prompt }, { headers: headers(token) });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("admin-prompt");
        toast.success("Prompt salvo");
      },
      onError: () => {
        toast.error("Falha ao salvar o prompt");
      },
    }
  );
};

export const useResetPrompt = () => {
  const { token } = useAdminAuth();
  const queryClient = useQueryClient();
  return useMutation<void, Error, void>(
    async () => {
      await adminApi.delete("/prompt", { headers: headers(token) });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("admin-prompt");
        toast.success("Prompt restaurado para o padrão");
      },
      onError: () => {
        toast.error("Falha ao restaurar o prompt");
      },
    }
  );
};
